import React, { useState } from 'react';
import styles from './vendorRegn.module.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { useDispatch, useSelector } from 'react-redux';
import { setVendorData } from '../../redux/vendorSlice';
const VendorRegn = () => {
    const [passwordVisible, setPasswordVisible] = useState(false);
    const [confirmPasswordVisible, setConfirmPasswordVisible] = useState(false);
    const [agreementstatus, setAgrimentStatus] = useState(false)
    const vendorData = useSelector((state) => state.vendor.vendorData);
    const { appearences } = useSelector((state) => state.appearences)
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const togglePasswordVisibility = () => {
        setPasswordVisible(!passwordVisible);
    };
    // Formik setup
    const formik = useFormik({
        initialValues: {
            fullName: vendorData.fullName || '',
            phone: vendorData.phone || '',
            email: vendorData.email || '',
            companyName: vendorData.companyName || '',
            gstn: vendorData.gstn || '',
            password: vendorData.password || '',
            confirmPassword: vendorData.confirmPassword || ''
        },
        validationSchema: Yup.object({
            fullName: Yup.string().required('Full name is required'),
            phone: Yup.string()
                .required('Phone number is required')
                .matches(/^[6-9]\d{9}$/, 'Invalid phone number'),
            email: Yup.string()
                .email('Invalid email address')
                .required('Email is required'),
            companyName: Yup.string().required('Company name is required'),
            gstn: Yup.string()
                .required('GSTN is required')
                .matches(
                    /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/,
                    'Invalid GSTN format'
                ),
            password: Yup.string().required('Password is required'),
            confirmPassword: Yup.string()
                .oneOf([Yup.ref('password')], 'Passwords must match')
                .required('Confirm password is required')
        }),
        onSubmit: (values) => {
            dispatch(setVendorData(values));
            if (agreementstatus) {
                navigate('/vendorBillingAddress');
            }
        }
    });
    return (
        <>
            <div className={styles.loginContainer}
                style={{
                    backgroundImage: `url(${appearences?.loginBanner?.image || '/assets/login.png'})`,
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "center center",
                    backgroundAttachment: "fixed",
                    backgroundSize: 'cover',
                    // height: '100vh',
                }}
            >
                <div className={styles.loginInner}>

                    <div className={styles.loginCol1} onClick={() => navigate('/')}>
                        <img src='/assets/logo.png' alt="Logo" />
                    </div>
                    <div className={styles.loginCol2}>
                        <div className={styles.loginCard}>
                            <div className={styles.loginCardHead}>
                                <h3>Vendor Registration</h3>
                            </div>
                            <div className={styles.hrseparator}></div>
                            <div className={styles.loginContent}>
                                <form className={styles.loginForm} onSubmit={formik.handleSubmit}>
                                    <div className={styles.loginFormRow1}>
                                        <div className={styles.loginInputGroup}>
                                            <label>Full Name</label>
                                            <input
                                                type="text"
                                                placeholder="Enter full name"
                                                {...formik.getFieldProps('fullName')}
                                            />
                                            {formik.touched.fullName && formik.errors.fullName ? <div className={styles.error}>{formik.errors.fullName}</div> : null}
                                        </div>
                                        <div className={styles.loginInputGroup}>
                                            <label>Phone number</label>
                                            <input
                                                type="text"
                                                placeholder="Enter phone number"
                                                {...formik.getFieldProps('phone')}
                                            // maxLength={10}
                                            />
                                            {formik.touched.phone && formik.errors.phone ? <div className={styles.error}>{formik.errors.phone}</div> : null}
                                        </div>
                                        <div className={styles.loginInputGroup}>
                                            <label>Email Address</label>
                                            <input
                                                type="email"
                                                placeholder="Enter company email id"
                                                {...formik.getFieldProps('email')}
                                            />
                                            {formik.touched.email && formik.errors.email ? <div className={styles.error}>{formik.errors.email}</div> : null}
                                        </div>
                                    </div>
                                    <div className={styles.loginFormRow2}>
                                        <div className={styles.loginInputGroup2}>
                                            <label>Company name</label>
                                            <input
                                                type="text"
                                                placeholder="Enter company name"
                                                {...formik.getFieldProps('companyName')}
                                            />
                                            {formik.touched.companyName && formik.errors.companyName ? <div className={styles.error}>{formik.errors.companyName}</div> : null}
                                        </div>
                                        <div className={styles.loginInputGroup2}>
                                            <label>GSTN number</label>
                                            <input
                                                type="text"
                                                placeholder="Enter GST number"
                                                {...formik.getFieldProps('gstn')}
                                            />
                                            {formik.touched.gstn && formik.errors.gstn ? <div className={styles.error}>{formik.errors.gstn}</div> : null}
                                        </div>
                                    </div>
                                    <div className={styles.loginFormRow2}>
                                        <div className={styles.loginInputGroup2}>
                                            <label>Password</label>
                                            <div className={styles.passwordContainer}>
                                                <input
                                                    type={passwordVisible ? 'text' : 'password'}
                                                    placeholder="Enter Password"
                                                    {...formik.getFieldProps('password')}
                                                    className={styles.passwordInput}
                                                />
                                                <FontAwesomeIcon
                                                    icon={passwordVisible ? faEyeSlash : faEye}
                                                    className={styles.passwordIcon}
                                                    onClick={togglePasswordVisibility}
                                                />
                                            </div>
                                            {formik.touched.password && formik.errors.password ? <div className={styles.error}>{formik.errors.password}</div> : null}
                                        </div>
                                        <div className={styles.loginInputGroup2}>
                                            <label>Confirm Password</label>
                                            <div className={styles.passwordContainer}>
                                                <input
                                                    type={confirmPasswordVisible ? 'text' : 'password'}
                                                    placeholder="Enter confirm password"
                                                    {...formik.getFieldProps('confirmPassword')}
                                                    className={styles.passwordInput}
                                                />
                                                <FontAwesomeIcon
                                                    icon={confirmPasswordVisible ? faEyeSlash : faEye}
                                                    className={styles.passwordIcon}
                                                    onClick={() => setConfirmPasswordVisible(!confirmPasswordVisible)}
                                                />
                                            </div>
                                            {formik.touched.confirmPassword && formik.errors.confirmPassword ? <div className={styles.error}>{formik.errors.confirmPassword}</div> : null}
                                        </div>
                                    </div>
                                    {/* <button type="submit" className={styles.loginButton}>Continue</button> */}
                                    <div className={styles.loginAccLinksCheck}>
                                        <input type="checkbox" onChange={() => setAgrimentStatus(!agreementstatus)} />
                                        <p> I agree to electrowiz <a href="#"><span>registration agreement</span></a></p>
                                    </div>
                                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                                        <button type="submit" className={styles.loginButton}>Continue</button>
                                    </div>
                                </form>
                                <div className={styles.loginAccLinks}>

                                    <div className={styles.loginSeparator} >
                                        <div className={styles.separator}></div>
                                        <p>Already have an account? <span onClick={() => navigate('/login')} style={{ cursor: 'pointer' }}>LOGIN</span></p>

                                        <div className={styles.separator}></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}

export default VendorRegn